import { useState } from 'react';
import { PromotedServiceAssignment } from '@mews-commander/data-access';
import { closeAlerts, useDialog } from '@mews/framework';

export const useServicePromotionFormDialog = () => {
    const [{ onClose, active: isFormOpen }, openDialog] = useDialog();
    const [promotedService, setPromotedService] = useState<PromotedServiceAssignment | undefined>();

    const openEditDialog = (service: PromotedServiceAssignment) => {
        setPromotedService(service);
        closeAlerts();
        openDialog();
    };

    const openFormDialog = () => {
        closeAlerts();
        openDialog();
    };

    const handleCloseDialog = () => {
        onClose();
        setPromotedService(undefined);
    };
    return { isFormOpen, openFormDialog, handleCloseDialog, openEditDialog, promotedService };
};
